// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3iv8M","header":"ReportDetails_header__3wARd","title":"ReportDetails_title__25Vti","left":"ReportDetails_left__3rHO2"};